/**
 * Generate a temporary password matching the pattern: xxxxxx-xxxxxx-xxxxxx
 * where x is a lowercase letter (a-z), uppercase letter (A-Z), or digit (0-9)
 *
 * Password must meet validation requirements:
 * - At least 10 characters
 * - Contains at least one uppercase letter (A-Z)
 * - Contains at least one lowercase letter (a-z)
 * - Contains at least one digit (0-9)
 * - Contains at least one special character from: .!@#$%^&*()[]{}-_+=~|:;"'<>,./?
 *
 * Example output: "Wyqkaq-nOmxo9-vyRdof"
 */
export const generateTemporaryPassword = (): string => {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz'
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const digits = '0123456789'
  const allChars = lowercase + uppercase + digits

  const generateSegment = (length: number, includeUpper: boolean = false): string => {
    let segment = ''
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * allChars.length)
      segment += allChars[randomIndex]
    }
    return segment
  }

  // Generate 3 segments of 6 characters each
  // Mix of upper, lower, and digits to meet requirements
  const segment1 = generateSegment(6)
  const segment2 = generateSegment(6)
  const segment3 = generateSegment(6)

  // Ensure we have at least one uppercase, one lowercase, and one digit
  // by forcefully setting specific positions if needed
  let password = `${segment1}-${segment2}-${segment3}`

  // Check and ensure requirements
  if (!/[A-Z]/.test(password)) {
    // Add uppercase at random position in first segment
    const pos = Math.floor(Math.random() * 6)
    password = password.substring(0, pos) + uppercase[Math.floor(Math.random() * uppercase.length)] + password.substring(pos + 1)
  }

  if (!/[a-z]/.test(password)) {
    // Add lowercase at random position in second segment
    const pos = 7 + Math.floor(Math.random() * 6)
    password = password.substring(0, pos) + lowercase[Math.floor(Math.random() * lowercase.length)] + password.substring(pos + 1)
  }

  if (!/[0-9]/.test(password)) {
    // Add digit at random position in third segment
    const pos = 14 + Math.floor(Math.random() * 6)
    password = password.substring(0, pos) + digits[Math.floor(Math.random() * digits.length)] + password.substring(pos + 1)
  }

  // Note: The hyphen (-) character serves as the required special character

  return password
}
